import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
import VueBootstrap from 'bootstrap-vue'
import "bootstrap-vue/dist/bootstrap-vue.css";
import {i18n} from '@/setup/i18n-setup'

Vue.config.productionTip = false;

Vue.use(Argon);
Vue.use(VueBootstrap);
console.log(i18n.messages)
new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount("#app");
